import type { CSSProperties, ReactNode } from "react";
import { getPalette } from "../../lib/child-presets";
import "./child-theme.scss";

export type ChildAppearance = { colorPalette?: string; emoji?: string };

/** One set of child-owned colors for every activity and all of its states. */
export function childThemeStyle(child: ChildAppearance): CSSProperties {
  const palette = getPalette(child.colorPalette);
  return {
    "--primary": palette.primary,
    "--surface-border": "color-mix(in srgb, var(--primary) 18%, #d8dfd8)",
    "--action-fill": "color-mix(in srgb, var(--primary) 55%, #17324d)",
    "--primary-light": palette.primaryLight,
    "--primary-bg": palette.primaryBg,
    "--primary-ink": "color-mix(in srgb, var(--primary) 65%, #17324d)",
    "--sky": palette.primaryBg,
    "--bg": palette.primaryBg,
    "--border": palette.primaryLight,
    "--cream": palette.primaryBg,
    "--line": palette.primaryLight,
    "--orange": palette.primaryBg,
    "--orange-dark": palette.primary,
    "--blue": palette.primary,
    "--blue-dark": "var(--ink)",
    "--sun": palette.primary,
    "--sun-dark": palette.primaryLight,
    "--accent": palette.primary,
    "--accent-light": palette.primaryBg,
  } as CSSProperties;
}

export function ChildIdentity({ name, emoji, children }: { name: string; emoji?: string; children?: ReactNode }) {
  return <div className="child-identity">
    {emoji && <span className="child-identity__avatar" aria-hidden="true">{emoji}</span>}
    <span className="child-identity__name">{name}</span>
    {children}
  </div>;
}
